import { OnDemandSessionMembershipsV1NaptimeResource } from './__generated__/OnDemandSessionMembershipsV1';

export default class OnDemandSessionMembershipsV1 extends OnDemandSessionMembershipsV1NaptimeResource {
  static RESOURCE_NAME = 'onDemandSessionMemberships.v1' as const;

  static byUserAndCourse(
    userId: string,
    courseId: string,
    options: {
      includes?: ['sessions'];
      fields?: ['sessionId'];
    } = {}
  ) {
    return this.finder('activeByUserAndCourse', {
      params: { userId, courseId },
      ...options,
    });
  }
}
